<!-- Divider -->
<div class="zop-horizontal-navigation-item-wrapper divider" [ngClass]="item.classes?.wrapper"></div>